// extracted by mini-css-extract-plugin
module.exports = {"row":"_95UmG-Re","cell":"_IRfCc8-v"};